<ng-container *ngIf="!inEdit">
    <div style="height: 320px; overflow-y: auto;" cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let item of helpMenuItems; let i = index" class="list-item d-flex align-items-center px-3 py-2" cdkDrag cdkDragPreviewContainer="parent" cdkDragBoundary=".k-dialog-content">
            <i class="mdi-editor-drag-handle grey-text font-size-1-3 mr-2 cursor-move"></i>
            <span class="flex-grow-1 cursor-pointer" (click)="startEdit(item)">
                {{ item.title }}
            </span>
            <!-- <i class="mdi-hardware-keyboard-arrow-up cursor-pointer grey-text font-size-1-3 mr-1" [class.disabled-icon]="i === 0" (click)="moveUp(i)"></i>
            <i class="mdi-hardware-keyboard-arrow-down cursor-pointer grey-text font-size-1-3 mr-2" [class.disabled-icon]="i === helpMenuItems.length - 1" (click)="moveDown(i)"></i> -->
            <i class="mdi-action-delete cursor-pointer pink-text font-size-1-3" (click)="deleteItem(i)"></i>
        </div>
        <div *ngIf="helpMenuItems.length === 0" class="px-3 py-2 grey-text text-darken-2">
            Nicio resursă adăugată.
        </div>
    </div>
    <button class="col-auto py-2 border-0 text-left add-line-btn" (click)="addItem()">
        <i class="mdi-content-add mr-2"></i>
        <span i18n="@@Actions$AddNewLine">Adaugă</span>
    </button>
    <div class="d-flex justify-content-around align-items-center pt-3 pb-2">
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Save" (click)="saveAll()">
            Salvează
        </button>
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Cancel" (click)="this.cancel.emit()">
            Renunță
        </button>
    </div>
</ng-container>

<ng-container *ngIf="inEdit">
    <div class="px-3 pt-3" style="height: 360px; overflow-y: auto;">
        <inputfield label="Titlu" [(ngModel)]="editingItem.title"></inputfield>
        <inputfield label="Link" [(ngModel)]="editingItem.link"></inputfield>
        <inputfield label="Descriere" [(ngModel)]="editingItem.description"></inputfield>
    </div>
    <div class="d-flex justify-content-around align-items-center pt-3 pb-2">
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Save" (click)="saveItemEdit()">
            {{ editingIndex === -1 ? 'Adaugă' : 'Modifică' }}
        </button>
        <button class="btn waves-effect waves-light" type="button" name="action" i18n="@@Actions$Cancel" (click)="cancelItemEdit()">
            Înapoi
        </button>
    </div>
</ng-container>
